/*
  Adapter to make checkbox compatible with Rsuite Form
*/

import type { FormControlProps } from 'rsuite'

import React, { useCallback } from 'react'

import { Form, Checkbox } from 'rsuite'

const Wrapper: React.FC<FormControlProps> = (props) => {
  const { defaultValue, value, onChange, ...rest } = props
  const handleChange = useCallback(
    (_value: any, checked: boolean, event: any) => {
      onChange?.(checked, event)
    },
    [ onChange ]
  )

  return (
    <Checkbox
      defaultChecked={!!defaultValue}
      checked={value}
      onChange={handleChange}
      {...rest}
    />
  )
}

const Control: React.FC<FormControlProps> = (props: FormControlProps) => (
  <Form.Control accepter={Wrapper} {...props} />
)

export default {
  Control,
  Checkbox: Wrapper
}
